// extracted by mini-css-extract-plugin
export default {"error_message":"error-box_error_message__MEGY5","error_box_content":"error-box_error_box_content__hlFKg"};